var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"ma-0",staticStyle:{"overflow-x":"hidden"},attrs:{"no-gutters":""}},[_c('v-col',{attrs:{"cols":"12"}},_vm._l((_vm.structure),function(component,index){return _c(component,{key:index,tag:"component",staticClass:"mb-3",attrs:{"wrap":true}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }